import React, { useState, useEffect } from 'react';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import "../../styles/Auth/resetPasswordPopup.css";
import { postData, getData } from '../../webService/webservice.js';
import { toast } from 'react-toastify';

const PasswordResetPopup = ({ token, onClose }) => {
    console.log("Reset Token:", token);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [touched, setTouched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [backgroundImages, setBackgroundImages] = useState([]);
    const [bgIndex, setBgIndex] = useState(0);

    // Fetch background images
    useEffect(() => {
        const fetchBackgrounds = async () => {
            try {
                const response = await getData('appearance/backgrounds');
                if (response?.data) {
                    const images = response.data.map(bg => `${process.env.REACT_APP_API_URL}${bg.uri}`);
                    setBackgroundImages(images);
                }
            } catch (error) {
                console.error("Failed to load backgrounds:", error);
            }
        };
        fetchBackgrounds();
    }, []);

    // Rotate background images
    useEffect(() => {
        if (backgroundImages.length === 0) return;
        const interval = setInterval(() => {
            setBgIndex((prev) => (prev + 1) % backgroundImages.length);
        }, 6000);
        return () => clearInterval(interval);
    }, [backgroundImages]);

    const handleReset = async () => {
        if (!newPassword || !confirmPassword) {
            setError('Both fields are required.');
            return;
        } else if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        // Simulate backend call
        try {
            setError('');
            setIsLoading(true);
            const route = `users/user/resetpassword/${token}`;
            const data = { newPassword };

            const result = await postData(route, data);
            setIsLoading(false);
            setSuccess(true);
            toast.success(result.message || 'Password reset successfully');
        } catch (error) {
            setIsLoading(false);
            setError(error.message || 'Error resetting password');
        }

    };

    return (
        <div className="reset-password-card">
            <div className="reset-card-bg-overlay"></div>
            {backgroundImages.map((img, index) => (
                <div
                    key={index}
                    className={`reset-card-bg-img ${index === bgIndex ? 'active' : ''}`}
                    style={{ backgroundImage: `url(${img})` }}
                ></div>
            ))}

            <div className="reset-card-content">
                <div className='reset-password-logo'>
                    <img className='logo' src='/assets/logo.png' alt='logo' />
                    <p className='reset-password-title'>Set New Password</p>
                </div>

                {success ? (
                    <>
                        <p className="reset-success-msg">Your password has been reset and updated successfully!</p>
                        <button className="reset-btn" onClick={onClose}>Go to Login</button>
                    </>
                ) : (
                    <>
                        <div className="reset-input-group">
                            <FaLock className="reset-input-icon" />
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                placeholder="New Password"
                                className="reset-input"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <span
                                className="reset-toggle"
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        <div className="reset-input-group">
                            <FaLock className="reset-input-icon" />
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Confirm Password"
                                className="reset-input"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <span
                                className="reset-toggle"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        {error && <p className="reset-error-msg">{error}</p>}

                        <div className="reset-button-row">
                            <button className="reset-btn" onClick={handleReset} disabled={isLoading}>
                                {isLoading ? <span className="button-spinner"></span> : 'Reset Password'}
                            </button>
                        </div>
                        <button className="reset-btn-cancel" onClick={onClose}>Cancel</button>
                    </>
                )}
            </div>
        </div>
    );
};

export default PasswordResetPopup;
